var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConsolidationUnionEditLabelAdmin',{attrs:{"CUL":_vm.CUL,"warehousesData":_vm.warehousesData},on:{"saveConsolidationUnionLabel":_vm.saveConsolidationUnionLabel}})
}
var staticRenderFns = []

export { render, staticRenderFns }